
var threshold = .8
var options = {
	root: null,
	rootMargin: '0px',
	threshold: threshold
}
window.addEventListener("DOMContentLoaded", function () {
	var observer = new IntersectionObserver(handleIntersect, options)
	var targets = document.querySelectorAll('.paragraph .field > *')
	targets.forEach(function (target) {
		// target.classList.add("animating");
		observer.observe(target)
	})
	
})
var handleIntersect = function (entries, observer) {
	entries.forEach(function (entry,i) {
		// console.log(threshold,entry.intersectionRatio)
		if (entry.intersectionRatio > threshold) {
			animateParagraph(entry.target,i);
			observer.unobserve(entry.target)
		}
	})
}


var animateParagraph = function(el,i){
		anime({
			targets: el,
			translateY: [{value: [30, 0],duration: 1200,delay: i*120}],
			opacity: [{value: [0, 1],duration: 1200,delay: i*120}],
			easing: 'easeOutExpo',
		});
		setTimeout(() => {
			el.classList.remove("animating");	
		}, 2000);
		
}


